import moment from 'moment';
// Suppress moment deprecation warnings
moment.suppressDeprecationWarnings = true;

export function castToMoment(value) {
    let momentVal;
    if (typeof value === 'number') {
        // First attempt unix seconds constructor
        momentVal = moment.unix(value);

        // If not valid, or unreasonable year, try milliseconds constructor
        if (!momentVal.isValid() || momentVal.year() > 5000) {
            momentVal = moment.utc(value);
        }
    } else {
        momentVal = moment.utc(value);
    }

    return momentVal;
}
